import { imageForDetectionID } from '../api/faces'
export function updateFaceWithLastSeen ({ face, lastSeen }) {
  if (lastSeen) {
    face.last_seen_datetime = lastSeen.last_seen_timestamp
    face.last_seen_camera_description = lastSeen.last_seen_camera_description
    face.last_seen_preview = imageForDetectionID(lastSeen.detection_id)
    face.last_seen_frame_uri = imageForDetectionID(lastSeen.detection_id, { fullFrame: true })
    face.last_seen_camera_uuid = lastSeen.last_seen_camera_uuid
    face.last_seen_detection_id = lastSeen.detection_id
  } else {
    face.last_seen_datetime = undefined
    face.last_seen_camera_description = undefined
    face.last_seen_preview = undefined
    face.last_seen_frame_uri = undefined
    face.last_seen_camera_uuid = undefined
    face.last_seen_detection_id = undefined
  }
  return face
}
